import React, { useEffect, useRef, useState } from 'react'

import './dropdown.css'

const Dropdown = props => {
    const [open, setOpen] = useState(false)
    const dropdown_toggle_el = useRef(null)
    const dropdown_content_el = useRef(null)

    useEffect(() => {
        if (!open) return

        const handlePointerDown = (e) => {
            if (dropdown_toggle_el.current?.contains(e.target)) return
            if (!dropdown_content_el.current?.contains(e.target)) setOpen(false)
        }
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setOpen(false)
        }

        document.addEventListener('mousedown', handlePointerDown)
        document.addEventListener('keydown', handleKeyDown)
        return () => {
            document.removeEventListener('mousedown', handlePointerDown)
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [open])

    return (
        <div className='dropdown'>
            <button
                ref={dropdown_toggle_el}
                type="button"
                className="dropdown__toggle"
                onClick={() => setOpen((v) => !v)}
                aria-haspopup="menu"
                aria-expanded={open}
            >
                {
                    props.icon ? <i className={props.icon}></i> : ''
                }
                {
                    props.badge ? <span className='dropdown__toggle-badge'>{props.badge}</span> : ''
                }
                {
                    props.customToggle ? props.customToggle() : ''
                }
            </button>
            <div
                ref={dropdown_content_el}
                role="menu"
                className={open ? "dropdown__content active" : "dropdown__content"}
                onClick={() => setOpen(false)}
            >
                {
                    props.contentData && props.renderItems ? props.contentData.map((item, index) => props.renderItems(item, index)) : ''
                }
                {
                    props.renderFooter ? (
                        <div className="dropdown__footer">
                            {props.renderFooter()}
                        </div>
                    ) : ''
                }
            </div>
        </div>
    )
}

export default Dropdown
